<template>
  <v-col class="tm-col">
    <div class="tm-box-frame">
      <tm-list-frame></tm-list-frame>
    </div>
  </v-col>
</template>

<script>
import TmListFrame from "../../../components/pc/TmListFrame.vue";

export default {
  components: {
    TmListFrame
  },
  activated() {
    /** 表示コンテンツのセット */
    this.$store.commit("app/setContent", "TmList");
  }
};
</script>

<style lang="scss" scoped>
.tm-col {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 0;
  & * + * {
    margin-top: 16px;
  }
}

.tm-box-frame {
  flex: 1;
  height: 100%;
}
</style>
